import { render, staticRenderFns } from "./prescriptionImage.vue?vue&type=template&id=082dc127&scoped=true"
import script from "./prescriptionImage.vue?vue&type=script&lang=js"
export * from "./prescriptionImage.vue?vue&type=script&lang=js"
import style0 from "./prescriptionImage.vue?vue&type=style&index=0&id=082dc127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082dc127",
  null
  
)

export default component.exports